import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from '../../styles/detalleIndividual.module.css';

const DetalleIndividual = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    void id;

    return (
        <div className={styles.container}>
            <button type="button" className={styles.backBtn} onClick={() => navigate('/creatividades/respuestas')}>
                ← Volver al listado
            </button>

            <header className={styles.header}>
                <h1 className={styles.title}>Resultado individual</h1>
                <p className={styles.emptyState}>No hay datos disponibles para esta respuesta.</p>
            </header>
        </div>
    );
};

export default DetalleIndividual;
